export class InterceptorConstants {
    private static readonly prefix = 'CustomHeader_';

    static readonly UseInterceptors = InterceptorConstants.prefix + 'UseInterceptors';
    static readonly RequestName = InterceptorConstants.prefix + 'RequestName';
    static readonly NoCache = InterceptorConstants.prefix + 'NoCache';
}
